import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import portfolioData from '../data/portfolioData';

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="container">
      <div className="footer__inner">
        <p className="footer__copy">
          © {new Date().getFullYear()} Dimitri Bonsou. Tous droits réservés.
        </p>
        <div className="footer__links">
          <a
            href={portfolioData.contact.github}
            target="_blank"
            rel="noopener noreferrer"
            className="footer__link"
            aria-label="GitHub"
          >
            <FaGithub size={18} />
          </a>
          <a
            href={portfolioData.contact.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="footer__link"
            aria-label="LinkedIn"
          >
            <FaLinkedin size={18} />
          </a>
          <a
            href={`mailto:${portfolioData.contact.email}`}
            className="footer__link"
            aria-label="Email"
          >
            <FaEnvelope size={18} />
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;